import SharedAsset from '@zenbusiness/zui/SharedAsset';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const LogoLottieRoot = superstyled({
  name: 'Logo',
  slot: 'Root',
  tag: SharedLottieAsset,
  styles: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    margin: 0
  })
});

export const LogoRoot = superstyled({
  name: 'Logo',
  slot: 'Root',
  tag: SharedAsset,
  styles: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    margin: 0
  })
});
